// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import axios from "axios"
import store from './store'
import VueAMap from 'vue-amap'

axios.defaults.baseURL = 'https://api2.baostart.com/api'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '094582920cb115e023c2b5d413277ef8', // 自己到官网申请，我随便写的
    plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'Geocoder'],//plugin所要用到的模块功能，按需添加
    v: '1.4.4',//高德 sdk 版本为 1.4.4
});
// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
    config => {
        if (localStorage.getItem('userToken')) {
            config.headers.Authorization = localStorage.getItem('userToken');
            // config.headers.token = 1;
        }
        return config;
    },
    error => {
        this.$router.push({ path: '/login' });
        return Promise.reject(error);
    }
);

Vue.prototype.getUrlCurrent = function () {
    /*概览*/
    var that = this;
    var currentUrl = this.$route.path;
    if (currentUrl.search('/home') != -1) {
        that.tabNumber = 0;
    } else if (currentUrl.search('/charter') != -1 || currentUrl.search('/charterDetails') != -1) {
        that.tabNumber = 1;
    } else if (currentUrl.search('/offer') != -1) {
        that.tabNumber = 2;
    } else if (currentUrl.search('/information') != -1 || currentUrl.search('/informationDetails') != -1) {
        that.tabNumber = 3;
    } else if (currentUrl.search('/join') != -1) {
        that.tabNumber = 4;
    }
    /*else if (currentUrl.search('/travel') != -1) {
        that.tabNumber = 5;
    }*/
    else if (currentUrl.search('/about') != -1) {
        that.tabNumber = 5;
    } else if (currentUrl.search('/quotation') != -1) {
        that.tabNumber = -1;
    } else if (currentUrl.search('/feedback') != -1) {
        that.tabNumber = -1;
    } else if (currentUrl.search('/customtrips') != -1) {
        that.tabNumber = -1;
    }
}

Vue.prototype.goPAGE = function () {
    if ((navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ))) {
        /*window.location.href="你的手机版地址";*/

        var pageurl = window.location.href;
        /*if (pageurl.search('360.baostart.com') != -1) {
            window.location.href = 'http://m.baostart.com/#/';
        } else if (pageurl.search('http://www.1788play.com/') != -1) {
            window.location.href = 'http://m.baostart.com/#/';
        } else if (pageurl.search('http://1788play.com') != -1) {
            window.location.href = 'http://m.baostart.com/#/';
        } else if (pageurl.search('http://lituchuxing.com/') != -1) {
            window.location.href = 'http://m.lituchuxing.com/#/';
        } else if (pageurl.search('http://www.lituchuxing.com/') != -1) {
            window.location.href = 'http://m.lituchuxing.com/#/';
        } else {
            window.location.href = 'http://mb.baostart.com/#/';
        }*/
        // console.log("pc wap");

        if (pageurl.search('http://ww.baostart.com') != -1) {
            window.location.href = 'http://mb.baostart.com/#/';
        } else {
            window.location.href = 'http://mb.baostart.com/#/';
        }
    } else {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
        if (userAgent.indexOf("BIDUBrowser") > -1) {
            //return "baidu";
            //alert("baidu");
            window.location.href = "/";
        } //判断是否是百度浏览器
    }
}

/* eslint-disable no-new */
/*new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    mounted() {
        this.goPAGE();
    }
})*/

new Vue({
    el: '#app',
    router,
    render: h => h(App),
    store,
    components: { App },
    template: '<App/>',
    mounted() {
        this.goPAGE();
        setTimeout(() => {
            document.dispatchEvent(new Event('render-event'))
        }, 5000)
    }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js